import {
  getCasinoTicketStates, getCasinoTickets, getCasinoTicketsByCashdeskId, markCasinoTicketAsDelivered
} from './api';

import CasinoMiddlewareAuth from './auth';

class CasinoMiddleware {
  static set credientals(data) {
    CasinoMiddlewareAuth.credientals = data;
  }

  static set authData(data) {
    CasinoMiddlewareAuth.authData = data;
  }

  static set onUnauthorize(cb) {
    CasinoMiddlewareAuth.onUnauthorize = cb;
  }

  static async getTicketStates(externalIds) {
    const result = await getCasinoTicketStates(externalIds);
    return result.Data;
  }

  static async getTickets(externalIds) {
    const result = await getCasinoTickets(externalIds);
    return result.Data;
  }

  static async getTicketsByCashdeskId(cashdeskId) {
    const result = await getCasinoTicketsByCashdeskId(cashdeskId);
    return result?.Data;
  }

  static async markTicketAsDelivered(betGuid) {
    const result = await markCasinoTicketAsDelivered({ TicketId: betGuid });
    return result.Success;
  }
}

export default CasinoMiddleware;
